import { render, staticRenderFns } from "./pageManagement.vue?vue&type=template&id=588d6f58&scoped=true"
import script from "./pageManagement.vue?vue&type=script&lang=js"
export * from "./pageManagement.vue?vue&type=script&lang=js"
import style0 from "./pageManagement.vue?vue&type=style&index=0&id=588d6f58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588d6f58",
  null
  
)

export default component.exports